import { compose } from 'ramda';

import { anonymousOnly } from '../../guards';
import { saveReturnPath } from '../../../../store/location/actions';

export const path = '/login';
export const component = 'Login';

export const thunk = () => (dispatch, getState) => {
  if (anonymousOnly(dispatch, getState)) return;
  compose(dispatch, saveReturnPath)();
};
